<template>
  <v-layout row justify-center>
    <v-flex xs6>
      <v-dialog v-model="offersDialog" max-width="1200px" scrollable>
        <v-card>
          <v-card-title class="headline font-weight-light">{{
              offersDialogTitle
          }}</v-card-title>
          <v-card-text>
            <!-- Offers for Selected Record -->
            <v-layout row wrap>
              <v-flex xs12 class="py-2 text-xs-right">
                <v-btn-toggle mandatory v-model="offersType" @change="checkExpandedView()">
                  <v-btn flat value="ALL">
                    {{ messages.label.OFFERS_TYPE_ALL }}
                  </v-btn>
                  <v-btn flat value="HD">
                    {{ messages.label.OFFERS_TYPE_HD }}
                  </v-btn>
                  <v-btn flat value="SD">
                    {{ messages.label.OFFERS_TYPE_SD }}
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
              <v-layout>
                <v-flex xs12 sm12>
                  <v-data-table :headers="headers" :items="assetOffers" :search="offersType"
                    :custom-filter="filterOffers" :loading="offersLoading" hide-actions :pagination.sync="pagination">
                    <!-- Items -->
                    <template slot="items" slot-scope="props" height="100%">
                      <tr @click="showExpandedView(props.item)" class="pointer">
                        <td class="text-xs-left">
                          {{ props.item.offerFormat }}
                        </td>
                        <td class="text-xs-left">{{ props.item.title }}</td>
                        <td class="text-xs-left">
                          {{ props.item.rightsWindowStart }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.rightsWindowEnd }}
                        </td>
                        <td class="text-xs-left">{{ props.item.price }}</td>
                        <td class="text-xs-left" v-if="!expandedView">
                          {{ props.item.offerType }}
                        </td>
                        <td class="text-xs-left" v-if="!expandedView">
                          {{ props.item.affiliate }}
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data">
                      <v-alert :value="true" color="error" icon="warning">
                        {{ messages.info.NO_ASSET_OFFERS }}
                      </v-alert>
                    </template>
                    <template slot="no-results">
                      <v-alert :value="true" color="info" class="black--text" icon="warning">
                        {{
                            messages.info.NO_FILTER_OFFERS.replace(
                              "offersType",
                              offersType
                            )
                        }}
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12 sm6 v-if="expandedView">
                  <v-card raised height="100%" dark>
                    <v-card-title class="headline font-weight-light">
                      {{ selectedRow.title }}
                      <v-spacer></v-spacer>
                      <v-btn flat icon color="blue lighten-2" @click="closeExpandedView()">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-layout>
                        <v-flex xs12 sm12>
                          <v-list two-line subheader darken-2>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Type</v-list-tile-title>
                                <v-list-tile-sub-title>{{
                                    selectedRow.offerType
                                }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Affiliate</v-list-tile-title>
                                <v-list-tile-sub-title>{{
                                    selectedRow.affiliate
                                }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Provider</v-list-tile-title>
                                <v-list-tile-sub-title>{{
                                    selectedRow.providerName
                                }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Wholesale Price</v-list-tile-title>
                                <v-list-tile-sub-title>{{
                                    selectedRow.wholesalePrice
                                }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-flex>
                        <v-flex xs12 sm12>
                          <v-list two-line subheader>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Alternate IDs</v-list-tile-title>
                                <template v-for="(item, index) in getAlternateIDsArray(
                                  selectedRow.alternateIds
                                )">
                                  <v-list-tile-sub-title :key="index">{{
                                      item
                                  }}</v-list-tile-sub-title>
                                </template>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Tags</v-list-tile-title>
                                <v-list-tile-sub-title>{{
                                    getOfferTags(selectedRow.offerTags)
                                }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>Target Entity</v-list-tile-title>
                                <v-list-tile-sub-title>{{
                                    selectedRow.targetEntity
                                }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="closeOffersDialog()">{{
                messages.label.CLOSE
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex"
import PreIngestService from "@/PreIngest/PreIngestService"
import * as preIngestDataService from "@/PreIngest/PreIngestDataService"
import { VOD_SYCN_OFFERING_WEB_SERVICE_URL } from "@/store/constants/getter-types"
import messages from "@/PreIngest/messages.json"

export default {
  name: "AssetOffers",
  data() {
    return {
      offersDialog: false,
      expandedView: false,
      selectedRow: {},
      assetOffers: [],
      offersLoading: false,
      selectedRecord: {},
      headers: this.getTableHeaders(),
      offersType: "ALL",
      offersDialogTitle: "",
      pagination: {
        sortBy: "rightsWindowStart",
        rowsPerPage: 10
      }
    }
  },
  computed: {
    ...mapGetters([VOD_SYCN_OFFERING_WEB_SERVICE_URL])
  },
  watch: {
    expandedView: function (value) {
      if (value) {
        this.headers = [
          {
            text: messages.label.TH_FORMAT,
            align: "left",
            value: "offerFormat"
          },
          {
            text: messages.label.TH_TITLE,
            align: "left",
            value: "title"
          },
          {
            text: messages.label.TH_START,
            align: "left",
            value: "rightsWindowStart"
          },
          {
            text: messages.label.TH_END,
            align: "left",
            value: "rightsWindowEnd"
          },
          {
            text: messages.label.TH_PRICE,
            align: "left",
            value: "price"
          }
        ]
      } else {
        this.headers = [
          {
            text: messages.label.TH_FORMAT,
            align: "left",
            value: "offerFormat"
          },
          {
            text: messages.label.TH_TITLE,
            align: "left",
            value: "title"
          },
          {
            text: messages.label.TH_START,
            align: "left",
            value: "rightsWindowStart"
          },
          {
            text: messages.label.TH_END,
            align: "left",
            value: "rightsWindowEnd"
          },
          {
            text: messages.label.TH_PRICE,
            align: "left",
            value: "price"
          },
          {
            text: messages.label.TH_TYPE,
            align: "left",
            value: "offerType"
          },
          {
            text: messages.label.TH_AFFILIATE,
            align: "left",
            value: "affiliate"
          }
        ]
      }
    }
  },
  methods: {
    /**
     * Retrieve offers for selectedProcessingRecord
     */
    retrieveAssetOffers() {
      this.offersLoading = true
      let queryObject = {
        byAssetReference: this.selectedRecord.paid,
        count: true
      }
      preIngestDataService
        .retrieveAssetOffers(
          queryObject,
          this.VOD_SYCN_OFFERING_WEB_SERVICE_URL
        )
        .then(response => {
          this.assetOffers = response.data.entries
          this.pagination.rowsPerPage = response.data.totalResults
          this.offersLoading = false
          this.openOffersDialog()
        })
        .catch(() => {
          this.assetOffers = []
          this.pagination.rowsPerPage = 10
          this.offersLoading = false
          this.openOffersDialog()
        })
    },
    /**
     * filterOffers - filtering assetOffers based on offersType
     * @return {array}  filteredOffers
     */
    filterOffers(items, search, filter) {
      if (search === "ALL") {
        return items
      } else {
        search = search.toString().toLowerCase()
        return items.filter(row => filter(row["offerFormat"], search))
      }
    },
    /**
     * checkExpandedView - Close expandedView if open
     */
    checkExpandedView() {
      if (this.expandedView) {
        this.expandedView = false
      }
    },
    /**
     * getOfferTags - Convert offerTags array into string
     * @return {string}  string combining all offerTags
     */
    getOfferTags(tagsArray) {
      let tagsString = ""
      if (!this.$lodash.isUndefined(tagsArray)) {
        tagsString = tagsArray.join()
      }
      return tagsString
    },
    /**
     * getAlternaeIDsArray - constructing IDsArray
     * @return {Array}  structured array with custom elements
     */
    getAlternateIDsArray(IDsObject) {
      let IDsArray = []
      if (!this.$lodash.isUndefined(IDsObject)) {
        for (var key in IDsObject) {
          let arrayItem = IDsObject[key] + " (" + key + ")"
          IDsArray.push(arrayItem)
        }
        return IDsArray
      }
    },
    /**
     * showExpandedView - Show expanded View for detailed information
     */
    showExpandedView(item) {
      this.expandedView = true
      this.selectedRow = item
    },
    /**
     * closeExpandedView - Hide expanded View for detailed information
     */
    closeExpandedView() {
      this.expandedView = false
      this.selectedRow = {}
    },
    /**
     * getTableHeaders - Retrieve table headers
     *
     * @return {array}  array of objects describing table columns
     */
    getTableHeaders() {
      let headers = [
        {
          text: messages.label.TH_FORMAT,
          align: "left",
          value: "offerFormat"
        },
        {
          text: messages.label.TH_TITLE,
          align: "left",
          value: "title"
        },
        {
          text: messages.label.TH_START,
          align: "left",
          value: "rightsWindowStart"
        },
        {
          text: messages.label.TH_END,
          align: "left",
          value: "rightsWindowEnd"
        },
        {
          text: messages.label.TH_PRICE,
          align: "left",
          value: "price"
        },
        {
          text: messages.label.TH_TYPE,
          align: "left",
          value: "offerType"
        },
        {
          text: messages.label.TH_AFFILIATE,
          align: "left",
          value: "affiliate"
        }
      ]
      return headers
    },
    /**
     * openOffersDialog - Show dialog for offers
     */
    openOffersDialog() {
      this.offersDialogTitle =
        this.messages.title.ASSET_OFFERS +
        ' "' +
        this.selectedRecord.title +
        '" (' +
        this.selectedRecord.paid +
        ")"
      this.offersDialog = true
    },
    /**
     * closeOffersDialog - Close Offers Dialog
     */
    closeOffersDialog() {
      this.offersDialog = false
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     * */
    PreIngestService.$on("event:showAssetOfferings", processingRecord => {
      this.selectedRecord = processingRecord
      this.retrieveAssetOffers()
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/PreIngest/ProcessingRecords/AssetOffers.vue